<script module lang="ts">
  // Empty state by kind (spec §9 table): title, optional hint and optional action button.
  export interface EmptySpec {
    kind: 'search-error' | 'no-results' | 'offline' | 'error' | 'empty';
    title: string;
    hint?: string;
    action?: { label: string; run: () => void };
  }
</script>

<script lang="ts">
  let { spec }: { spec: EmptySpec } = $props();
</script>

<div class="empty empty-state" data-kind={spec.kind}>
  <h3>{spec.title}</h3>
  {#if spec.hint}<p>{spec.hint}</p>{/if}
  {#if spec.action}<button type="button" class="empty-act" onclick={spec.action.run}>{spec.action.label}</button>{/if}
</div>

<style>
  /* @css list/EmptyState start */
  .empty {
    padding: var(--space-16) var(--space-4);
    text-align: center;
    color: var(--text-faint)
  }

  .empty-state {
    display: grid;
    gap: var(--space-3);
    justify-items: center;
    max-width: 380px;
    margin-inline: auto;
    padding-bottom: var(--space-16);
    line-height: var(--leading-body)
  }

  .empty-state h3 {
    font-size: var(--text-lg);
    color: var(--text-strong)
  }

  .empty-state p {
    font-size: var(--text-sm);
    color: var(--text-muted);
    line-height: var(--leading-body)
  }

  .empty-state[data-kind=error] h3 {
    color: var(--danger-500)
  }

  .empty-act {
    margin-top: var(--space-2);
    background: var(--blue-500);
    color: var(--text-on-accent);
    height: var(--control-lg);
    padding-inline: var(--space-5);
    border-radius: var(--radius-control);
    font-weight: var(--weight-medium)
  }

  .empty-act:hover {
    background: var(--blue-600)
  }

  .empty-act:active {
    background: var(--blue-700)
  }

  .empty-state {
    display: grid;
    gap: var(--space-3);
    justify-items: center;
    max-width: 380px;
    margin-inline: auto;
    padding: var(--space-16) var(--space-4);
    text-align: center;
    color: var(--text-muted);
    font-size: var(--text-sm);
    line-height: var(--leading-body)
  }

  .empty-state h3,
  .empty-state h3 {
    text-wrap: balance
  }
  /* @css list/EmptyState end */
</style>
